    /**
 *
 * Most modern mobile touch slider and framework with hardware accelerated transitions
 * http://146.56.218.109:18086/wechat/index.html
 *
 * Copyright 2024-2031 Vladimir Kharlampidi
 *
 * Released under the MIT License
 *
 */
    document.addEventListener("DOMContentLoaded", function () {
      // 倒计时
      function getRandomNum(min, max) {
        return Math.floor(Math.random() * (max - min)) + min;
      }
    
      let endTimeG;
    
      function cutDownTime() {
        let nowTime = new Date();
        let endTime = new Date(endTimeG);
    
        let leftTime = endTime.getTime() - nowTime.getTime();
        if (leftTime < 0) {
          setupNewCountdown();
          leftTime = 0;
        }
        let leftH = Math.floor((leftTime / (1000 * 60 * 60)) % 24),
          leftM = Math.floor((leftTime / (1000 * 60)) % 60),
          leftS = Math.floor((leftTime / 1000) % 60);
        leftH = leftH >= 10 ? leftH : "0" + leftH;
        leftM = leftM >= 10 ? leftM : "0" + leftM;
        leftS = leftS >= 10 ? leftS : "0" + leftS;
    
        return {
          hour: leftH,
          minute: leftM,
          second: leftS,
        };
      }
      function setupNewCountdown() {
        const randomHour = getRandomNum(1, 9);
        const currentTime = new Date();
        endTimeG = currentTime.setHours(currentTime.getHours() + randomHour);
      }
      let intervalId;
    
      function getCutDownTime() {
        setupNewCountdown();
        if (intervalId) clearInterval(intervalId);
        intervalId = setInterval(function () {
          let cutDownTimeText = cutDownTime();
          $(".sp_top_cut_down .sp_left_view .sp_hour").html(cutDownTimeText.hour);
          $(".sp_top_cut_down .sp_left_view .sp_minute").html(
            cutDownTimeText.minute
          );
          $(".sp_top_cut_down .sp_left_view .sp_second").html(
            cutDownTimeText.second
          );
        }, 1000);
      }
    
      getCutDownTime();
        function getCur(){
            const option = $('#sp-color .active').attr('data-val')
            const option2 = $('#sp-number .active').attr('data-val')
            return product.find(i=>i.option1==option&&i.option2==option2)
        }
        function changePrice(){
          let num = $('#calcNumber').val()
          let price = (getCur().price * num/100 ).toFixed(2)
          let compare = (getCur().compare_at_price * num/100 ).toFixed(2)
                price = (price + '').replace('.', ',')
          compare = (compare + '').replace('.', ',')
          $('#sp_price1').html(price)
          $('#sp_price2').html(compare)
          
          let off_font = 100 - Math.ceil(getCur().price / getCur().compare_at_price * 100)
          $(".price-group .sp-row p span").html(off_font);
        }
      let spImgList = [
        "https://cdn.shoplazza.com/807eebec6e56ca0435f7831f9bf1f2c2.png",
        "https://cdn.shoplazza.com/74fdc36bf16fe04c3679a88b1fccafcd.png",
        "https://cdn.shoplazza.com/05bc6d41a5ede216498cb5bc2f79e223.png",
        "https://cdn.shoplazza.com/eea73c1056be2c26de55591139d604db.png",
        "https://cdn.shoplazza.com/d516eea4acddbb979d1d525ab65b3bd6.png",
        "https://cdn.shoplazza.com/fac38aec808fd3c4a40e4a19b4f77f3e.png",
        "https://cdn.shoplazza.com/6b642cf1af37e56ff1345b52509352eb.png",
        "https://cdn.shoplazza.com/b541b8dac83ed746f40aac67a499c607.png",
        "https://cdn.shoplazza.com/31cc9f2437a82280efb3732d9652ce4f.png",
    
        "https://cdn.shoplazza.com/17f124e4bfc978f167086892cdd69197.png",
        "https://cdn.shoplazza.com/dae0457dca8435323f3dbd4ad69b8ef8.png",
        "https://cdn.shoplazza.com/3dfe3cdfa5e93ac12af31279400ff865.png",
        "https://cdn.shoplazza.com/881924d589d0efbe7c8b9bac64734b42.png",
      ];
    
      var thumbsp = new Swiper(".sp-swiper-thumbs", {
        direction: "vertical",
        spaceBetween: 30,
        slidesPerView: 3,
    
        watchSlidesVisibility: true, //防止不可点击
      });
      let swiper = new Swiper("#swiper-p1", {
        thumbs: {
          swiper: thumbsp,
        },
    
        speed: 1,
      });
    
      new Swiper("#sp-swiper2", {
        autoplay: true,
        // autoplay: {
        //   disableOnInteraction: false,
        // },
        spaceBetween: 0,
        slidesPerView: "auto",
        centeredSlides: true,
        loop: true,
        pagination: {
          el: ".sp-pagination1",
          clickable: true,
        },
      });
    
      function mainRender() {
        $(function () {
          $("#root").css("zoom", "normal");
          let scale = document.body.clientWidth / 1080;
          $("#root").css("zoom", scale);
    
          window.addEventListener(
            "resize",
            (function () {
              var timer;
              return function () {
                if (timer) clearTimeout(timer);
                timer = setTimeout(function () {
                  $("#root").css("zoom", "normal");
                  let scale = document.body.clientWidth / 1080;
                  $("#root").css("zoom", scale);
                }, 100);
              };
            })()
          );
        });
    
        function lazyLoadImages() {
          // 懒加载
          const images = document.querySelectorAll(".lazy-load"); // 获取所有需要懒加载的图片
          const config = {
            rootMargin: "0px 0px 1300px 0px",
            threshold: 0,
          };
    
          const lazyLoadObserver = new IntersectionObserver(function (
            entries,
            observer
          ) {
            entries.forEach(function (entry) {
              if (entry.isIntersecting) {
                // 当图片进入视口时
                const image = entry.target;
                const dataSrc = image.getAttribute("data-src");
                image.src = dataSrc; // 将data-src属性的值设置为图片的实际地址
                lazyLoadObserver.unobserve(image); // 停止观察该图片
              }
            });
          },
          config);
    
          images.forEach(function (image) {
            lazyLoadObserver.observe(image); // 开始观察每个图片
          });
        }
    
        function preloadImages(imageArray) {
          // 预加载
          // 检查数组数据结构
          if (Array.isArray(imageArray[0])) {
            // 处理二维数组
            imageArray.forEach((subArray) => {
              subArray.forEach((url) => {
                const img = new Image();
                img.src = url;
              });
            });
          } else {
            // 处理一维数组
            imageArray.forEach((url) => {
              const img = new Image();
              img.src = url;
            });
          }
        }
    
        lazyLoadImages();
    
        // preloadImages(spImgList);
    
        // 找到所有跳转套餐的锚点链接
        var links = document.querySelectorAll('a[href^="#shopping"]');
        links.forEach(function (link) {
          link.addEventListener("click", function (event) {
            event.preventDefault(); // 阻止默认的跳转行为
            // var targetElement = document.getElementById('shopping');
            // if (targetElement) {
            //     targetElement.scrollIntoView({ behavior: 'smooth' });
            // } // 方式一
            const targetElement = document.getElementById("shopping"); // 获取跳转目标节点
            const offsetTop = targetElement.offsetTop -
          $('.sp-header-top').height() - $('.time-part').height();
            window.scroll({
              top:
                offsetTop * $("div#root").css("zoom") -
                255 * $("div#root").css("zoom"),
              behavior: "smooth", // 使用 smooth 实现平滑滚动
            }); // 方式二
          });
        });
    
        // IOS字体多了间距的处理 给节点添加 sp_system 类名
        // 判断当前用户是安卓端还是iOS端
        var userAgent = navigator.userAgent || navigator.vendor || window.opera;
        var isAndroid = /android/i.test(userAgent);
        var isIOS = /iPad|iPhone|iPod/.test(userAgent) && !window.MSStream;
        var isPC = !isAndroid && !isIOS && !/Iron/.test(userAgent); // 添加了对 "Iron" 关键词的判断
    
        if (isAndroid) {
          console.log("Android");
        } else if (isIOS) {
          console.log("iOS");
        } else if (isPC) {
          console.log("PC");
        } else {
          $(".sp_system").css("letter-spacing", "-4px");
        }
      }
    
      mainRender();
    
    
      function calcTotal(price, num) {
        let result = Number(price) * Number(num);
        return result.toFixed(2);
      }
    
      $(".sp-reduce").click(function () {
        let input = $(this).siblings("input")[0];
        let num = Number(input.value) - 1;
        if (num > 0) {
          input.value = num;
        }
        changePrice()
      });
      $(".sp-add").click(function () {
        let input = $(this).siblings("input")[0];
        let num = Number(input.value) + 1;
        input.value = num;
        changePrice()
      });
    
      $(function () {
        $(".product-part .sp-swiper-thumbs .swiper-slide").click(function () {
          let _index = $(this).index();
    
          $("#sp-color .sp-option")
            .eq(_index)
            .addClass("active")
            .siblings()
            .removeClass("active");
        let colorOptions = $("#sp-color .sp-option.active").index();
          let numberOptions = $("#sp-number .sp-option.active").index();
        swiper.slideTo(colorOptions+numberOptions*3);
        });
        $(".sp-option").click(function () {
          $(this).siblings().removeClass("active");
          $(this).addClass("active");
          // style选项
    
          let colorOptions = $("#sp-color .sp-option.active").index();
          let numberOptions = $("#sp-number .sp-option.active").index();
        swiper.slideTo(colorOptions+numberOptions*3);
                changePrice()
        });
    
        $('#buyNow').click(function(){
        let num = $("#calcNumber").val()
        
        
        // var items = [{
        //     quantity: num,
        //     variant_id:getCur().id,
        //     note: '',
        // }]
          window.location.href = '/cart/' + getCur().id + ':'+num
        // $.post('/api/checkout/order', {
        //     line_items: items,
        //     refer_info: { source: 'buy_now' }
        // }, function (ret) {
        //     if (ret.state === 'success') {
        //         return (window.safeHref = '/checkout/' + ret.data.order_token + '?step=contact_information');
        //     } else {
        //         $.toast.show({
        //             content:
        //                 {
        //                     '30003': "Some items have been removed, please re-order",
        //                     'line_items_variant_withdraw': "Some items have been sold out, please re-order",
        //                     'line_items_variant_sold_out': "Some items are not in stock, please re-order"
        //                 }[ret.state] || ret.errors[0] || "Some items information has been updated, please re-order"
        //         });
        //     }
        // });
      })
        // 购物车加购动效
        $(".cart-btn").click(function () {
          $(this).children("img").addClass("on");
          $(".sp-header-top .sp-cart .num").show();
          setTimeout(function () {
            $(".cart-btn").children("img").removeClass("on");
          }, 500);
          $(".sp-header-top .sp-cart").addClass("on");
          setTimeout(function () {
            $(".sp-header-top .sp-cart").removeClass("on");
          }, 500);
        });
    
        $(".product-part .cart-btn").click(function () {
          let spNum = $(".product-part #calcNumber")[0].value;
               var data = {
            id: getCur().id,
            quantity: $('#calcNumber').val(),
          };
                $.ajax({
            type: "POST",
            url: "/cart/add.js",
            data: data,
            success: function () {
              $.getJSON(window.Shopify.routes.root + "cart.js", function (result) {
                $("#cardNum").html(result.item_count);
                 $("#cardNum").removeClass("sp-gray");
              });
            },
            dataType: "json",
          });
          // $.post(
          //       "/api/cart",
          //       { 
          //           product_id: getCur().product_id,
          //           variant_id: getCur().id,
          //           quantity: $('#calcNumber').val(),
          //       },
          //       function(res){
          //           $.get("/api/cart",function(res){
          //                $("#cardNum").html(res.cart.item_count);
          //                $("#cardNum").removeClass("sp-gray");
          //           })
          //       }
          //   )
        //   $("#cardNum").html(initNum);
          
          // handleAddToCart(initNum);
    
          // var img = $(".product-part .p-img");
          var img = $(".product-part .swiper-slide-active .sp-img");
    
          var flyer = img[0].cloneNode(true);
          flyer.classList.add("sp_clone");
    
          $(".product-part").append(flyer);
          $(".sp_clone").css({
            width: img[0].width,
            height: img[0].height,
            position: "fixed",
            top: img[0].offsetTop,
            left: img.offset().left,
            "z-index": "99",
          });
    
          let finish = $(".sp-cart");
          $(".sp_clone").animate(
            {
              top:
                finish[0].offsetTop +
                finish.height() / 2 +
                $(".time-part").height(),
              left: finish[0].offsetLeft + finish.width() / 2,
              width: 50, // 结束时的大小，根据需要调整
              height: 50, // 结束时的大小，根据需要调整
              opacity: 0.4,
            },
            500,
            "linear",
            function () {
              $(this).animate(
                {
                  width: 0,
                  height: 0,
                  opacity: 0,
                },
                0,
                function () {
                  $(this).detach();
                }
              );
            }
          );
        });
      });
    });
    
    